import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { PageContainer } from '@/components/layout/PageContainer'
import { Button } from '@/components/ui/button'
import { StorefrontSettingsGuard } from './StorefrontSettingsGuard'
import { OrderSettings } from './OrderSettings'
import { StockManagementSettings } from './StockManagementSettings'

export function OrderSettingsPage() {
  const navigate = useNavigate()

  return (
    <StorefrontSettingsGuard>
      <PageContainer>
        <div className="p-6 space-y-6">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              className="rounded-full"
              onClick={() => navigate('/storefront/settings')}
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div>
              <h2 className="text-2xl font-semibold">Orders & Payments</h2>
              <p className="text-sm text-muted-foreground">
                Slip verification, invoicing, and stock management
              </p>
            </div>
          </div>

          <OrderSettings />
          <StockManagementSettings />
        </div>
      </PageContainer>
    </StorefrontSettingsGuard>
  )
}
